import axios from "axios";

// ─────────────────────────────────────────────────────────────────────────────
// Bank Accounts ("Netplus Banks") — dedicated API client.
// Own base path (/api/bank-accounts), own service file. Shares nothing with
// any other module.
// ─────────────────────────────────────────────────────────────────────────────
const API_BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:5001";
const BASE = `${API_BASE_URL}/api/bank-accounts`;

const multipart = () => ({ headers: { "Content-Type": "multipart/form-data" } });

export const baListAccounts = () => axios.get(BASE);

export const baCreateAccount = (payload) => axios.post(BASE, payload);

// payload: { name?, notes?, openingBalance? } — corrects a mis-entered
// opening balance (e.g. wrong Dr/Cr side at account creation) without
// needing to delete the account and re-upload every statement.
export const baUpdateAccount = (accountId, payload) =>
  axios.patch(`${BASE}/${accountId}`, payload);

export const baGetLedger = (accountId, params = {}) =>
  axios.get(`${BASE}/${accountId}/ledger`, { params });

export const baListUploads = (accountId) => axios.get(`${BASE}/${accountId}/uploads`);

export const baUploadStatement = (accountId, formData) =>
  axios.post(`${BASE}/${accountId}/upload`, formData, multipart());

export const baUpdateEntryLabel = (entryId, label) =>
  axios.patch(`${BASE}/entries/${entryId}`, { label });

export const baDeleteUpload = (uploadId) => axios.delete(`${BASE}/uploads/${uploadId}`);

// Triggers a browser download of the exported workbook.
export const baExportLedger = async (accountIds, params = {}) => {
  const response = await axios.get(`${BASE}/export`, {
    params: { accountIds: accountIds.join(","), ...params },
    responseType: "blob",
  });
  const url = window.URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement("a");
  link.href = url;
  const disposition = response.headers["content-disposition"] || "";
  const match = disposition.match(/filename="?([^"]+)"?/);
  link.setAttribute("download", match ? match[1] : "bank-ledger.xlsx");
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
};
